<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 v-if="!loading">
                <div
                  id="firstDiagno"
                  v-for="(item, index) in data"
                  :key="index"
                >
                  <survey-item-card
                    class="test-diagno mb-5"
                    :itemData="item"
                    :answerData="answerData"
                    :index="index"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import SurveyService from "../../services/SurveyService";
import SurveyItemCard from "../../components/Surveys/SurveyItemCard.vue";

export default {
  data: () => {
    return {
      loading: false,
      data: [],
      answerData: [],
      page: 1,
      perPage: 50,
      paginationStop: false,
    };
  },
  components: {
    SurveyItemCard,
  },
  methods: {
    getSurveys() {
      this.loading = true;
      setPageLoading(true);
      SurveyService.getSurveys(this.page, this.perPage)
        .then((res) => {
          this.data = res.data;
          this.getAnswerSurvey();
        })
        .catch((err) => {
          showError(err);
          this.loading = false;
        })
        .then(() => {
          setPageLoading(false);
        });
    },

    getAnswerSurvey() {
      SurveyService.getAnswerSurvey(this.$store.state.user.Id)
        .then((res) => {
          this.answerData = res.data;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          setPageLoading(false);
          this.loading = false;
        });
    },

    paginationPage() {
      console.log("paginationPage");
      this.page++;
      //this.getFeedItems();
    },

    //Infinite scroll
    scrollTop(e) {
      if (!this.loading) {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100
        ) {
          if (!this.paginationStop) this.paginationPage();
        }
      }
    },
  },
  computed: {},
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop);
  },
  mounted() {
    this.getSurveys();
    window.addEventListener("scroll", this.scrollTop);
  },
  watch: {},
};
</script>

<style>
.fixed .v-card {
  position: fixed;
  min-width: 253.5px;
}

.fixed-in-flex {
  position: fixed;
}

.vue-sticky-el {
  z-index: 1 !important;
}

.word-wrap {
  word-break: break-word !important;
}
</style>
